import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="payment-cancel-page" className="grain-texture min-h-screen">
      <Navbar />

      <section className="py-32 bg-background">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-orange-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-12 h-12 text-orange-600" />
            </div>
            <h1 className="text-4xl font-serif mb-4 text-orange-700">Payment Cancelled</h1>
            <p className="text-lg text-muted-foreground mb-8">
              Your payment was cancelled. No charges have been made to your account.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => navigate("/packages")}
                data-testid="browse-packages-btn"
                className="bg-primary hover:bg-primary/90"
              >
                Browse Packages
              </Button>
              <Button
                onClick={() => navigate("/home")}
                data-testid="back-home-btn"
                variant="outline"
              >
                Back to Home
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaymentCancel;